let black = "#0a290f";
let white = "#fff";

// export const primaryColor = "#38fc43";
export const primaryColor = "#4ac456";
export const dark = black;
export const light = white;

export const borderRadius = "1rem";

export const CustomTheme = {
  token: {
    colorPrimary: primaryColor,
    colorInfo: primaryColor,
    fontSize: 14,
    borderRadius: 8,
  },

  components: {
    Button: {
      primaryShadow: "",
      borderRadius: 4,
    },
    Input: {
      hoverBorderColor: "transparent",
      colorBorder: "transparent",
      padding: "0px",
      margin: "0px",
      activeBorderColor: "transparent",
      activeBg: "transparent",
      activeShadow: "",
      border: 0,
    },
    Upload: {
      colorFillAlter: "transparent",
      padding: 0,
      borderRadiusLG: 16,
      colorBorder: "transparent",
      motionDurationSlow: "0.5s",
    },
    Popover: {
      borderRadiusLG: 12,
    },
  },
};
